import { effect, signal } from '@preact/signals';
import type { ThemePackValue } from '@amumin/api-client';
import { api } from '../api.js';
import { context } from './session.js';

export const personalTheme = signal<ThemePackValue | null>(null);
export const themeReady = signal(false);
export const themeLoadFailed = signal(false);

let generation = 0;
export async function loadPersonalTheme(): Promise<void> {
  const id = context.peek()?.identity.id;
  const request = ++generation;
  personalTheme.value = null;
  themeReady.value = false;
  themeLoadFailed.value = false;
  if (!id) return;
  try {
    const result = await api.app.auth.preferences();
    if (request !== generation || context.peek()?.identity.id !== id) return;
    personalTheme.value = result.theme;
    themeReady.value = true;
  } catch {
    if (request === generation && context.peek()?.identity.id === id) themeLoadFailed.value = true;
  }
}

export function installPersonalTheme(): () => void {
  let previous: string | undefined;
  return effect(() => {
    const id = context.value?.identity.id;
    if (id === previous) return;
    previous = id;
    void loadPersonalTheme();
  });
}

export async function savePersonalTheme(theme: ThemePackValue | null): Promise<void> {
  const id = context.peek()?.identity.id;
  if (!id) return;
  const result = await api.app.auth.setPreferences(theme);
  if (context.peek()?.identity.id === id) personalTheme.value = result.theme;
}
